/*@flow*/
export default function isLoggedIn(): %checks {
  return Boolean(
    window &&
      window.CONFIG &&
      window.CONFIG.ME &&
      Object.keys(window.CONFIG.ME).length > 0
  );
}
